import React from 'react';
import { connect } from 'react-redux'
import { Redirect } from 'react-router';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Link from '@material-ui/core/Link';
import PeopleIcon from '@material-ui/icons/People';
import Typography from "@material-ui/core/Typography";
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOffOutlined';

import Api from '../../../../../../common/api'
import Auth from '../../../../../../common/auth';
import Local from '../../../../../../common/local'
import Util from '../../../../../../common/util';
import Recaptcha from '../../../../../../common/components/recaptcha';

import CurrentUser from '../../../../shared/components/current-user';
import Heading from '../../../../shared/components/heading';
import LeftRail from '../../../../shared/components/left-rail';
import PopAlert from '../../../../shared/components/pop-alert';
import PageHeader from '../../../../shared/components/page-header';
import StandardInput from '../../../../shared/components/gn-standard-input';
import withTranslations from '../../../../../../common/components/with-translations';

const styles = (theme) => ({
  view: {
    ...theme.internalContainer,
    [theme.breakpoints.up('md')]: {
      padding: theme.internalContainer._themeMdPadding
    },
  },
  button: {
    borderRadius: '9999px',
    fontWeight: '600',
    fontSize: '16px',
    height: '55px',
    width: '100%',
  },
  buttonHover: {
    '&:hover': {
      backgroundColor: 'var(--button-hover-color) !important'
    },
  },
  buttonControls: {
    display: "flex",
    justifyContent: "center",
    marginTop: "15px"
  },
  guestText: {
    fontSize: '14px',
    paddingTop: '20px',
    textAlign: 'center'
  },
  noHeaderContainer: {
    padding: '20px 20px 0px 20px',
    maxWidth: '1200px',
    margin: '0 auto 50px auto'
  },
  infoText: {
    fontSize: '14px',
    textAlign: 'center'
  },
  linkText: {
    color: '#222222',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  signInText: {
    fontSize: '14px',
    paddingTop: '10px',
    textAlign: 'center'
  },
  stepTitle: {
    display: "flex",
    justifyContent: "center",
    fontWeight: '600',
    fontSize: '1.2rem',
    marginBottom: '10px',
  },
});

class StepValidateEmail extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      emailValidated: false,
      message: '',
      polling: false,
      pop: false,
      processing: false,
      username: props.username ? props.username : '',
      validateEmailSent: false,
      validation: {
        password: null,
        username: null,
      }
    };

    this.api = new Api();
    this.checkValidation = this.checkValidation.bind(this);
    this.generateOnInput = this.generateOnInput.bind(this);
    this.goGuest = this.goGuest.bind(this);
    this.goCreateAccount = this.goCreateAccount.bind(this);
    this.onPopClose = this.onPopClose.bind(this);
    this.onVerify = this.onVerify.bind(this);
    this.onSubmitPressed = this.onSubmitPressed.bind(this);
  }

  async checkValidation() {
    const validated = await Auth.emailIsValidated(this.state.username);

    if (validated) {
      this.setState({
        emailValidated: validated
      });
      return;
    }

    setTimeout(this.checkValidation, 5 * 1000);
  }

  generateOnInput(stateKey) {

    return function (e) {

      this.setState({
        [stateKey]: e.target.value,
        validation: { username: null, password: null }
      });
    }.bind(this);
  }

  goGuest(e) {
    e.preventDefault();
    this.props.goGuest(this.state.username);
  }

  goCreateAccount(e) {
    e.preventDefault();
    this.props.goCreateAccount(this.state.username);
  }

  onPopClose() {
    this.setState({
      pop: false
    });
  }

  async onSubmitPressed(e) {

    if (e.key === 'Enter') {
      return this.onVerify();
    }
  }

  async onVerify() {
    const { t } = this.props;
    const res = await Auth.userRequestVerify(this.props.dispatch, this.state.username, true, true);

    if (res.code === 412) {
      return this.props.onError({
        error: t('stepValidateEmail.accountExistsError')
      });
    } else if (res.code === 429) {
      return this.props.onError({
        error: t('stepValidateEmail.rateLimitedError')
      });
    } else if (res.code === 400) {
      return this.props.onError({
        error: res.content.message
      })
    }

    if (!this.state.polling) {
      setTimeout(this.checkValidation, 5 * 1000);
    }

    // Not an error, but use the toast
    this.setState({
      message: t('stepValidateEmail.verificationSentToast'),
      polling: true,
      pop: true,
      validateEmailSent: true,
    });
  }

  render() {
    const { t } = this.props;
    const containerStyle =
      this.props.query.noHeader ?
        this.props.classes.noHeaderContainer :
        this.props.classes.view;

    const endAdornment = this.state.showPassword ?
      <VisibilityOffIcon color="action" style={{ 'cursor': 'pointer' }} onClick={this.onShowPassword} /> :
      <VisibilityIcon color="action" style={{ 'cursor': 'pointer' }} onClick={this.onShowPassword} />;

    const endAdornmentWrapper = (
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={this.onShowPassword}
          edge="end"
        >
          {this.state.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
        </IconButton>
      </InputAdornment>
    )

    const emailInput = (
      <Grid item xs={12} md={12}>
        <StandardInput
          inputType="email"
          value={this.state.username}
          style={{ marginBottom: '15px', marginTop: '15px' }}
          error={this.state.validation.username}
          attribute="username"
          label={t('stepValidateEmail.emailLabel')}
          labelWidth={85}
          focus={true}
          onChange={this.generateOnInput('username')}
          onKeyUp={this.onSubmitPressed} />
      </Grid>
    );

    const displayableContent = this.props.application && this.props.application.displayable && this.props.application.displayable.content
      ? this.props.application.displayable.content
      : {};

    const buttonColor = displayableContent.buttonColor || (this.props.query.buttonColor && `#${this.props.query.buttonColor}`);
    const buttonHoverColor = displayableContent.buttonHoverColor || (this.props.query.buttonHoverColor && `#${this.props.query.buttonHoverColor}`);

    const buttonStyle = {
      ...(buttonColor && { backgroundColor: buttonColor }),
      ...(buttonHoverColor && { '--button-hover-color': buttonHoverColor }),
    };

    const buttonClassName = buttonHoverColor ?
      `${this.props.classes.button} ${this.props.classes.buttonHover}` :
      this.props.classes.button;

    const stepTitle = this.props.query.showSteps === 'true' ? (
      <Grid className={this.props.classes.stepTitle} item xs={12}>
        <Typography className={this.props.classes.stepTitle}>
          {t('stepValidateEmail.stepTitle')}
        </Typography>
      </Grid>
    ) : null;

    let view = (
      <Grid container spacing={1} className={containerStyle} >
        <PopAlert
          open={this.state.pop}
          message={this.state.message}
          onClose={this.onPopClose}
          hasExit={true}
        />
        {stepTitle}
        <Grid item xs={12} md={12}>
          <Typography>
            {t('stepValidateEmail.initialInstructions', {
              verifyEmail: (
                <Typography component="span" color='primary' display='inline'>{t('stepValidateEmail.verifyEmailButtonLabel')}</Typography>
              )
            })}
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography>
            {t('stepValidateEmail.sendExplanation')}
          </Typography>
        </Grid>
        {emailInput}
        <Grid className={this.props.classes.buttonControls} item xs={12}>
          <Button style={buttonStyle} className={buttonClassName} color="primary" onClick={this.onVerify} variant="contained" id="login">
            {this.state.processing ?
              (<CircularProgress size={14} color="inherit" />)
              : t('stepValidateEmail.verifyEmailButton')
            }
          </Button>
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography className={this.props.classes.signInText} color="initial" >
            <Link className={this.props.classes.linkText} onClick={this.goCreateAccount} to="/gn">{t('stepValidateEmail.backToCreateAccount')}</Link>
          </Typography>
        </Grid>
      </Grid>
    );

    if (this.state.validateEmailSent) {
      view = (
        <Grid container spacing={1} className={containerStyle} >
          <PopAlert
            open={this.state.pop}
            message={this.state.message}
            onClose={this.onPopClose}
            hasExit={true}
          />
          {stepTitle}
          <Grid item xs={12} md={12}>
            <Typography>
              {t('stepValidateEmail.sentConfirmation', {
                username: (
                  <Typography component='span' color='primary' display='inline'>{this.state.username}</Typography>
                )
              })}
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography>
              {t('stepValidateEmail.sentExpiryInfo')}
            </Typography>
          </Grid>
          <Grid className={this.props.classes.buttonControls} item xs={12}>
            <Button style={buttonStyle} className={buttonClassName} color="primary" onClick={this.onVerify} variant="contained" id="login">
              {this.state.processing ?
                (<CircularProgress size={14} color="inherit" />)
                : t('stepValidateEmail.resendButton')
              }
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography className={this.props.classes.signInText} color="initial" >
              <Link className={this.props.classes.linkText} onClick={this.goCreateAccount} to="/gn">{t('stepValidateEmail.backToCreateAccount')}</Link>
            </Typography>
          </Grid>
        </Grid>
      );
    }

    if (this.state.emailValidated) {
      view = (
        <Grid container spacing={1} className={containerStyle} >
          <PopAlert
            open={this.state.pop}
            message={this.state.message}
            onClose={this.onPopClose}
            hasExit={true}
          />
          {stepTitle}
          <Grid item xs={12} md={12}>
            <Typography>
              {t('stepValidateEmail.validatedConfirmation', {
                username: (
                  <Typography component='span' color='primary' display='inline'>{this.state.username}</Typography>
                )
              })}
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography>
              {t('stepValidateEmail.validatedInstructions')}
            </Typography>
          </Grid>
          <Grid className={this.props.classes.buttonControls} item xs={12}>
            <Button style={buttonStyle} className={buttonClassName} color="primary" onClick={this.goCreateAccount} variant="contained" id="login">
              {t('stepValidateEmail.backButton')}
            </Button>
          </Grid>
        </Grid>
      );
    }

    return view;
  }
}

const mapStateToProps = state => {
  return {
  };
}

const ConnectedStepValidateEmail = connect(mapStateToProps, null)(StepValidateEmail);

export default withTranslations(withStyles(styles)(ConnectedStepValidateEmail));
